import React, { useEffect, useState } from 'react';
import { CheckCircle2, Crown } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  country: 'México',
  type: 'basic' as const
}, {
  name: 'Carlos',
  country: 'Argentina',
  type: 'upgrade' as const
}, {
  name: 'Ana',
  country: 'España',
  type: 'basic' as const
}, {
  name: 'Luis',
  country: 'Colombia',
  type: 'upgrade' as const
}, {
  name: 'Sofia',
  country: 'Chile',
  type: 'basic' as const
}, {
  name: 'Valentina',
  country: 'Perú',
  type: 'upgrade' as const
}, {
  name: 'Diego',
  country: 'Uruguay',
  type: 'basic' as const
}, {
  name: 'Camila',
  country: 'Ecuador',
  type: 'upgrade' as const
}, {
  name: 'Roberto',
  country: 'Paraguay',
  type: 'upgrade' as const
}, {
  name: 'Luciana',
  country: 'Bolivia',
  type: 'basic' as const
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPurchase);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
      const nextDelay = Math.random() * 5000 + 10000 + 5000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  const isUpgrade = currentPurchase.type === 'upgrade';
  return <div className={`fixed bottom-4 right-4 md:bottom-8 md:right-8 bg-white rounded-lg shadow-2xl p-4 max-w-xs z-40 border-l-4 ${isUpgrade ? 'border-orange-500' : 'border-green-500'} flex items-center gap-3 animate-in slide-in-from-bottom-10 fade-in duration-500`} data-id="element-261">
      <div className={`${isUpgrade ? 'bg-orange-100' : 'bg-green-100'} p-2 rounded-full`} data-id="element-262">
        {isUpgrade ? <Crown className="w-6 h-6 text-orange-600" data-id="element-263" /> : <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-264" />}
      </div>
      <div data-id="element-265">
        <p className="text-sm font-bold text-gray-900" data-id="element-266">
          {currentPurchase.name} de {currentPurchase.country}
        </p>
        <p className="text-xs text-gray-600" data-id="element-267">
          {isUpgrade ? <>
              eligió la{' '}
              <span className="font-semibold text-orange-600" data-id="element-268">
                Compra Mejorada 🔥
              </span>
            </> : <>
              acaba de comprar{' '}
              <span className="font-semibold text-blue-600" data-id="element-269">
                Pack 100 Citas
              </span>
            </>}
        </p>
        <p className="text-[10px] text-gray-400 mt-1" data-id="element-270">Hace unos segundos</p>
      </div>
    </div>;
}